import React from 'react';
import { Card } from './ui/card';
import { Trophy, Globe, TrendingUp, Users, Target, Sparkles } from 'lucide-react';

export const WhyEnter = () => {
  const reasons = [
    {
      icon: Trophy,
      title: 'Global Recognition',
      description: 'Gain international prestige and credibility as a Stand Vision Awards winner, elevating your profile in the global exhibition design community.'
    },
    {
      icon: Globe,
      title: 'Industry Exposure',
      description: 'Showcase your work to thousands of industry professionals, potential clients, and decision-makers worldwide through our extensive network.'
    },
    {
      icon: TrendingUp,
      title: 'Career Growth',
      description: 'Stand out from competitors with an award-winning portfolio credential that opens doors to new opportunities and premium projects.'
    },
    {
      icon: Users,
      title: 'Expert Validation',
      description: 'Receive recognition from our distinguished jury panel of 20+ leading exhibition design professionals and industry experts.'
    },
    {
      icon: Target,
      title: 'Marketing Power',
      description: 'Leverage the Stand Vision Awards seal of excellence in your marketing materials, website, and client presentations.'
    },
    {
      icon: Sparkles,
      title: 'Inspire Excellence',
      description: 'Join a community of innovators and creative leaders who are setting new standards for the future of exhibition design.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50" data-testid="why-enter-section">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Why Enter Stand Vision Awards?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Winning a Stand Vision Award is more than recognition—it's a catalyst for growth, credibility, and new opportunities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <Card
              key={index}
              className="p-6 bg-white border shadow-sm hover:shadow-md transition-shadow"
              data-testid={`why-enter-card-${index}`}
            >
              <div className="flex flex-col items-center text-center">
                <div className="h-14 w-14 rounded-full bg-amber-100 flex items-center justify-center mb-4">
                  <reason.icon className="h-7 w-7 text-amber-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
